import { openDB } from 'idb';

const ALC_ATTACHMENTS_DB = "alc_attachments_db";
const ALC_ATTACHMENTS_STORE = "alc_files";
const DB_VERSION = 1;

export interface ALCStoredAttachment {
  key: string;
  tourId: string;
  checkpointId: string;
  areaName: string;
  remarks: string;
  fileData: string;
  fileName: string;
  mimeType?: string;
  uploaded?: boolean;
}

const getDB = async () => {
  return openDB(ALC_ATTACHMENTS_DB, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(ALC_ATTACHMENTS_STORE)) {
        db.createObjectStore(ALC_ATTACHMENTS_STORE, { keyPath: 'key' });
      }
    },
  });
};

export const saveALCAttachmentToIndexedDB = async (
  tourId: string,
  checkpointId: string,
  areaName: string,
  remarks: string,
  file: File | Blob
): Promise<string> => {
  const db = await getDB();
  const key = `alc_${tourId}_${checkpointId}_${Date.now()}`;
  
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async () => {
      try {
        const fileData = (reader.result as string) || "";
        const fileName = file instanceof File ? file.name : "alc_attachment.jpg";
        const mimeType = file instanceof File ? file.type : "image/jpeg";
        
        const payload: ALCStoredAttachment = {
          key,
          tourId,
          checkpointId,
            areaName,
          remarks,
          fileData,
          fileName,
          mimeType,
          uploaded: false,
        };
        
        await db.put(ALC_ATTACHMENTS_STORE, payload);
        resolve(key);
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
};

export const getPendingALCAttachments = async (): Promise<ALCStoredAttachment[]> => {
  const db = await getDB();
  const all = await db.getAll(ALC_ATTACHMENTS_STORE);
  return all.filter(item => !item.uploaded);
};

export const markALCAttachmentUploaded = async (key: string): Promise<void> => {
  const db = await getDB();
  const item = await db.get(ALC_ATTACHMENTS_STORE, key);
  if (item) {
    item.uploaded = true;
    await db.put(ALC_ATTACHMENTS_STORE, item);
  }
};

export const deleteALCAttachment = async (key: string): Promise<void> => {
  const db = await getDB();
  await db.delete(ALC_ATTACHMENTS_STORE, key);
};
